import React from 'react';
import GridItem from 'components/Grid/GridItem';
import { translate } from 'components/Translation';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import Button from 'components/CustomButtons/Button';
import styles from 'assets/jss/material-dashboard-pro-react/views/dashboard/bannerStyle.js';
import { Link, makeStyles } from '@material-ui/core';
import Tag from 'components/Tag/Tag';
import CanPerform from 'components/CanPerform/CanPerform';
import { blackColor, dangerColor, whiteColor } from 'assets/jss/material-dashboard-pro-react';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import { useHistory } from 'react-router-dom';
import classNames from 'classnames';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IBannerProps {
	heading: string;
	tag?: string;
	description: string;
	buttonText: string;
	handleClick: Function;
	setFilters?: Function;
	action: string;
	backgroundColor?: string;
	buttonBackground?: string;
	buttonTextColor?: string;
	textColor?: string;
	badgeColor?: types.theme.badgeColor | string;
	linkText?: string;
	linkRoute?: string;
	buttonStyle?: string;
}

const Banner = ({
	heading,
	tag,
	description,
	buttonText,
	handleClick,
	action,
	backgroundColor,
	buttonBackground,
	buttonTextColor,
	textColor,
	badgeColor = 'danger',
	setFilters,
	linkText = '',
	linkRoute = '',
	buttonStyle,
}: IBannerProps) => {
	const classes = useStyles({
		backgroundColor,
		textColor: textColor || blackColor,
		buttonBackground,
		buttonTextColor,
	});
	const history = useHistory();
	return (
		<GridItem xs={12}>
			<Card className={classes.card}>
				<CardBody className={classes.cardBody}>
					<div className={classes.headerWrapper}>
						<div className={classes.headingMBold}>{heading}</div>
						{tag && <Tag text={tag} color={badgeColor} marginLeft={8} />}
					</div>
					<div className={classes.cardContentWrapper}>
						<div>
							<div className={classes.headingSBold}>{description}</div>
						</div>
						<CanPerform
							action={action}
							yes={
								<div className={classes.buttonWrapper}>
									<ConditionalRender
										show={!!linkText}
										onTrue={() => (
											<Button
												color="primary-light"
												onClick={() => {
													if (setFilters) setFilters();
													history.push(linkRoute);
												}}
												className={classNames({
													[classes.customButton]: buttonBackground || buttonTextColor,
													[classes.outLinedButtonDark]: true,
													[classes.customLink]: true,
												})}
											>
												{linkText}
											</Button>
										)}
									/>
									<Button
										color="primary-light"
										onClick={handleClick}
										className={classNames({
											[classes.customButton]: buttonBackground || buttonTextColor,
											[classes.outLinedButtonDark]:
												buttonStyle === 'light' && !(buttonBackground || buttonTextColor),
											[classes.outLinedButtonLight]:
												buttonStyle === 'dark' && !(buttonBackground || buttonTextColor),
										})}
									>
										{buttonText}
									</Button>
								</div>
							}
						/>
					</div>
				</CardBody>
			</Card>
		</GridItem>
	);
};

export default Banner;
